module.exports = __webpack_public_path__ + "img/cotto-sanitary-wares.687fb7b3.png";